import { $ } from "@/common/Axios";

export default {
  /**
   * 中军招生指标配置
   */
  armyEnrollTarget: {
    /*
     * 添加
     * areaTarget 折算后区域指标 (number query )
     * areas 负责区县， 多个逗号隔开 (string query )
     * enrollTeacherId 招生老师 (integer query )
     * id  (integer query )
     * month 月 (integer query )
     * target 折算后个人指标 (number query )
     * year 年 (integer query )
     */
    post: (p, c) => $.post("/api/bms/activity/armyEnrollTarget", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/armyEnrollTarget", p, c),
  },
  armyEnrollTarget_downloadMould: {
    /*
     * 下载指标导入模版
     */
    get: (p, c) =>
      $.get("/api/bms/activity/armyEnrollTarget/downloadMould", p, c),
  },
  armyEnrollTarget_export: {
    /*
     * 导出-基础平台-招生管理-中军招生指标
     */
    get: (p, c) => $.get("/api/bms/activity/armyEnrollTarget/export", p, c),
  },
  armyEnrollTarget_getCoefficient: {
    /*
     * 获取配置的指标系数
     */
    get: (p, c) =>
      $.get("/api/bms/activity/armyEnrollTarget/getCoefficient", p, c),
  },
  armyEnrollTarget_getStatisticsPageByMonth: {
    /*
     * 中军汇报数据
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/armyEnrollTarget/getStatisticsPageByMonth",
        p,
        c
      ),
  },
  armyEnrollTarget_listPage: {
    /*
     * 个人指标列表-基础平台-招生管理-中军招生指标
     */
    get: (p, c) => $.get("/api/bms/activity/armyEnrollTarget/listPage", p, c),
  },
  armyEnrollTarget_saveCoefficient: {
    /*
     * 配置指标系数
     * content 月 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/armyEnrollTarget/saveCoefficient", p, c),
  },
  armyEnrollTarget_upload: {
    /*
     * 导入指标
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/activity/armyEnrollTarget/upload", p, c),
  },

  /**
   * 免试专升本线索统计配置
   */
  exemptionDegreeClueStatistics: {
    /*
     * 添加
     * batch 退伍批次 (string query )
     * city 市 (string query )
     * district 区 (string query )
     * id  (integer query )
     * proRegisterCount 预计报道量 (integer query )
     * registerCount 报到量 (integer query )
     */
    post: (p, c) =>
      $.post("/api/bms/activity/exemptionDegreeClueStatistics", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/exemptionDegreeClueStatistics", p, c),
  },
  exemptionDegreeClueStatistics_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/activity/exemptionDegreeClueStatistics/export", p, c),
  },
  exemptionDegreeClueStatistics_getTokenConfig: {
    /*
     * 获取播报群token配置
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/exemptionDegreeClueStatistics/getTokenConfig",
        p,
        c
      ),
  },
  exemptionDegreeClueStatistics_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/exemptionDegreeClueStatistics/list", p, c),
  },
  exemptionDegreeClueStatistics_saveTokenConfig: {
    /*
     * 保存播报群token配置
     * content 内容： name, token (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/activity/exemptionDegreeClueStatistics/saveTokenConfig",
        p,
        c
      ),
  },
  exemptionDegreeClueStatistics_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/exemptionDegreeClueStatistics/upload", p, c),
  },
};
